"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgAlertTriangle = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_ALERT-TRIANGLE", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M8 4.5a1 1 0 0 0-1 1V8a1 1 0 0 0 2 0V5.5a1 1 0 0 0-1-1ZM8 10a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 8 10Z" }),
    React.createElement("path", { d: "M4.895 1.759C5.718.854 6.788 0 8 0s2.282.854 3.105 1.759c.872.96 1.697 2.237 2.406 3.569a28.06 28.06 0 0 1 1.766 4.068c.43 1.27.723 2.502.723 3.404 0 .803-.488 1.386-1.01 1.763-.518.375-1.193.646-1.903.845C11.656 15.811 9.806 16 8 16c-1.806 0-3.656-.189-5.087-.592-.71-.2-1.385-.47-1.904-.845C.49 14.186 0 13.603 0 12.8c0-.902.293-2.133.723-3.404A28.064 28.064 0 0 1 2.49 5.328c.709-1.332 1.534-2.61 2.406-3.57ZM2 12.788c.013.025.057.089.194.188.246.178.665.37 1.268.539 1.194.335 2.844.516 4.538.516 1.694 0 3.345-.18 4.538-.516.603-.17 1.022-.36 1.268-.54.137-.098.182-.162.194-.187-.003-.576-.21-1.556-.62-2.769a26.11 26.11 0 0 0-1.64-3.778c-.667-1.252-1.404-2.375-2.126-3.17C8.843 2.224 8.288 1.97 8 1.97c-.288 0-.843.254-1.614 1.103-.722.794-1.459 1.917-2.125 3.17a26.112 26.112 0 0 0-1.64 3.777c-.411 1.213-.618 2.193-.621 2.769Zm12.004-.013s0 .004-.003.01l.003-.01ZM2 12.785c-.003-.006-.003-.01-.003-.01l.003.01Z" }))); };
exports.default = SvgAlertTriangle;
